import { ExtensionTrustSettingsService } from '../extension-trust-settings.service';
import { Injectable } from '@angular/core';
import { LuigiNode } from '@openmfp/portal-ui-lib';

const TRUST_HANDLING_PATH = '/extension-trust-handling';

@Injectable({
  providedIn: 'root',
})
export class ExtensionTrustHandlingService {
  constructor(private trustService: ExtensionTrustSettingsService) {}

  public isTrustedProject(projectId: string): boolean {
    return this.trustService.isTrusted(projectId);
  }

  public convertToNoTrustHandlingNode(originalNode: LuigiNode): LuigiNode {
    return Object.assign({}, originalNode, {
      viewUrl: TRUST_HANDLING_PATH,
    });
  }
}
